import { PortalUserListAsyncView } from './view/PortalUserList.view';
import { usePortalUserListViewModel } from './view-model/PortalUserList.viewModel';

const PortalUserListPage = () => {
  const vm = usePortalUserListViewModel();
  return <PortalUserListAsyncView vm={vm} />;
};

export default PortalUserListPage;
